import { LegalLayout } from './LegalLayout';

/**
 * Phase 15.6 — Beta-Impressum mit Platzhalter-Warnung. Vor dem Public-Launch
 * (oder spätestens beim Wechsel von Closed-Beta zu Open-Beta) muss dieses
 * Dokument vollständig ausgefüllt werden.
 */
export default function Imprint() {
  return (
    <LegalLayout title="Impressum">
      {__IS_BETA__ && (
        <div className="rounded-md border border-amber-500/40 bg-amber-500/10 p-4 text-sm text-amber-100">
          ⚠️ <strong>Platzhalter-Impressum.</strong> Bitte vor Beta-Launch vollständig ausfüllen!
        </div>
      )}

      <div className="mt-6 space-y-5 text-sm leading-relaxed text-fg-secondary">
        <section>
          <h2 className="mb-2 font-display text-base font-semibold text-fg-primary">
            Angaben gemäß § 5 TMG
          </h2>
          <p>
            [VORNAME NACHNAME]
            <br />
            [STRASSE HAUSNR]
            <br />
            [PLZ ORT]
            <br />
            Deutschland
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display text-base font-semibold text-fg-primary">Kontakt</h2>
          <p>E-Mail: [DEINE EMAIL]</p>
        </section>

        <section>
          <h2 className="mb-2 font-display text-base font-semibold text-fg-primary">
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
          </h2>
          <p>[VORNAME NACHNAME]</p>
        </section>

        <section>
          <h2 className="mb-2 font-display text-base font-semibold text-fg-primary">
            Haftungsausschluss
          </h2>
          <p>
            Dispatch24 ist ein nicht-kommerzielles Hobby-Projekt im Closed-Beta-Stadium. Die
            dargestellten Inhalte dienen ausschließlich Unterhaltungszwecken und stellen keine
            echte Leitstellen-Software dar. Es besteht keine Verbindung zu offiziellen Behörden,
            Feuerwehren, Rettungsdiensten oder Polizei. Reale Wachen-Standorte werden über
            öffentliche OpenStreetMap-Daten geladen.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display text-base font-semibold text-fg-primary">
            Bildnachweise
          </h2>
          <p>Karten-Daten: © OpenStreetMap-Mitwirkende, lizenziert unter ODbL.</p>
        </section>
      </div>
    </LegalLayout>
  );
}
